import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Box,
  Typography,
} from '@mui/material';
import { Button } from '../../../Components/MUIs';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';

const AttendanceDialog = ({
  open,
  onClose,
  showNonAttendReason,
  nonAttendReason,
  setNonAttendReason,
  onNonAttendClick,
  onAttendConfirm,
  onNonAttendConfirm,
  onCancel
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: '20px',
          boxShadow: '0 8px 32px rgba(0,0,0,0.12)',
        },
      }}
    >
      <DialogTitle
        sx={{
          textAlign: 'center',
          fontWeight: 'bold',
          fontSize: '1.3rem',
          color: '#2c3e50',
          py: 3,
          borderBottom: '1px solid #e9ecef',
        }}
      >
        📅 회의 참석 여부 확인
      </DialogTitle>

      <DialogContent sx={{ textAlign: 'center', py: 4 }}>
        <Box sx={{ pt: 4 }}>
          <Typography
            sx={{
              mb: 1,
              color: '#2c3e50',
              fontWeight: 'bold',
              fontSize: '1.3rem',
            }}
          >
            회의에 참석하시겠습니까?
          </Typography>
          <Typography sx={{ color: '#6c757d' }}>
            참석 여부를 선택해주세요.
          </Typography>
        </Box>

        {/* 불참 사유 입력 필드 */}
        {showNonAttendReason && (
          <Box sx={{ mt: 3 }}>
            <TextField
              fullWidth
              multiline
              rows={5}
              placeholder="불참 사유를 입력해주세요."
              value={nonAttendReason}
              onChange={(e) => setNonAttendReason(e.target.value)}
              sx={{
                '& .MuiOutlinedInput-root': {
                  borderRadius: '12px',
                  backgroundColor: '#F8F8F8',
                },
              }}
            />
          </Box>
        )}
      </DialogContent>

      <DialogActions
        sx={{ justifyContent: 'center', gap: 2, pb: 4, px: 3 }}
      >
        {!showNonAttendReason ? (
          <>
            <Button
              name="불참"
              startIcon={<CancelIcon />}
              variant="outlined"
              onClick={onNonAttendClick}
              sx={{
                minWidth: '120px',
                height: '48px',
                borderRadius: '24px',
                borderColor: '#dc3545',
                color: '#dc3545',
                fontWeight: 'bold',
                fontSize: '1rem',
                '&:hover': {
                  borderColor: '#c82333',
                  backgroundColor: '#f8d7da',
                  transform: 'translateY(-1px)',
                },
                transition: 'all 0.2s ease-in-out',
              }}
            />
            <Button
              name="참석"
              startIcon={<CheckCircleIcon />}
              variant="contained"
              onClick={onAttendConfirm}
              sx={{
                minWidth: '120px',
                height: '48px',
                borderRadius: '24px',
                backgroundColor: '#2DB400',
                fontWeight: 'bold',
                fontSize: '1rem',
                '&:hover': {
                  backgroundColor: '#26a300',
                  transform: 'translateY(-1px)',
                  boxShadow: '0 4px 12px rgba(45, 180, 0, 0.3)',
                },
                transition: 'all 0.2s ease-in-out',
              }}
            />
          </>
        ) : (
          <>
            <Button
              name="취소"
              variant="outlined"
              onClick={onCancel}
              sx={{
                minWidth: '120px',
                height: '48px',
                borderRadius: '24px',
                borderColor: '#6c757d',
                color: '#6c757d',
                fontWeight: 'bold',
                fontSize: '1rem',
                '&:hover': {
                  borderColor: '#495057',
                  backgroundColor: '#f8f9fa',
                  transform: 'translateY(-1px)',
                },
                transition: 'all 0.2s ease-in-out',
              }}
            />
            <Button
              name="불참 확정"
              startIcon={<CancelIcon />}
              variant="contained"
              onClick={onNonAttendConfirm}
              disabled={!nonAttendReason.trim()}
              sx={{
                minWidth: '120px',
                height: '48px',
                borderRadius: '24px',
                backgroundColor: '#dc3545',
                fontWeight: 'bold',
                fontSize: '1rem',
                '&:hover': {
                  backgroundColor: '#c82333',
                  transform: 'translateY(-1px)',
                  boxShadow: '0 4px 12px rgba(220, 53, 69, 0.3)',
                },
                '&:disabled': {
                  backgroundColor: '#adb5bd',
                  transform: 'none',
                  boxShadow: 'none',
                },
                transition: 'all 0.2s ease-in-out',
              }}
            />
          </>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default AttendanceDialog;
